import { Link } from 'react-router-dom'

import { T } from '@tribeplatform/react-components/i18n'
import { Button } from '@tribeplatform/react-ui-kit/Button'
import { EmptyState } from '@tribeplatform/react-ui-kit/EmptyState'
import { SvgIcon } from '@tribeplatform/react-ui-kit/Icon'

type ForgotPassEmailSentProps = {
  emailAddress: string
}

export const ForgotPassEmailSent = ({
  emailAddress,
}: ForgotPassEmailSentProps) => (
  <div className="sm:mx-auto sm:w-full sm:max-w-md p-5 py-12">
    <EmptyState
      icon={<SvgIcon name="mail" />}
      title={
        <T defaultMessage="Check your email" id="Auth.ForgotPass.CheckEmail" />
      }
      description={
        <>
          <p className="mt-5 text-center text-sm text-content-on-background-subdued">
            <T
              defaultMessage="If we find an account associated with the email address, we’ve sent a temporary link to reset your password."
              id="Auth.ForgotPass.CheckEmail.Notice.AccountExistence"
            />
          </p>
          <p className="mt-2 text-center text-sm text-content-on-background-subdued">
            <T
              defaultMessage="Please check your inbox at {email}."
              id="Auth.ForgotPass.CheckEmail.Notice.Inbox"
              values={{
                email: <strong>{emailAddress}</strong>,
              }}
            />
          </p>
        </>
      }
    >
      <Button variant="secondaryNeutral" as={Link} to="/auth/login" size="lg">
        <T
          defaultMessage="Back to login"
          id="Auth.ForgotPass.CheckEmail.Actions.BackToLogin"
        />
      </Button>
    </EmptyState>
  </div>
)
